import View from "./View";

function getBBox(el) {
  const bboxParent = el.offsetParent.getBoundingClientRect();
  const left = bboxParent.left + el.offsetLeft;
  const right = left + el.offsetWidth;
  const top = bboxParent.top + el.offsetTop;
  const bottom = top + el.offsetHeight;
  return { top, right, left, bottom };
}

/**
 * Base class for item views
 * @constructor
 * @extends View
 */
const ItemView = View.extend(
  /** @lends ItemView.prototype */
  {
    /**
     * Indicate visually, that the item is being dragged
     * @param {boolean} state - whether to hilite on or off
     */
    markDragged(state) {
      this.toggleClass("dragged", state);
    },

    getBBox() {
        let { top, right, bottom, left } = getBBox(this.elements[0]);

        for(let i = 1; i < this.elements.length; i++) {
            const bbox = getBBox(this.elements[i]);
            if(bbox.top < top) top = bbox.top;
            if(bbox.right > right) right = bbox.right;
            if(bbox.bottom > bottom) bottom = bbox.bottom;
            if(bbox.left < left) left = bbox.left;
        }

        return { top, right, bottom, left };
    },

    /**
     * Get squared distance of [x, y] from center. Coordinates are in client space.
     * @param {number} x
     * @param {number} y
     * @returns {number}
     */
    distanceSqr(x, y) {
      const { top, right, bottom, left } = this.getBBox();

      const cx = (left + right) / 2;
      const cy = (top + bottom) / 2;

      const dx = cx - x;
      const dy = cy - y;

      return dx * dx + dy * dy;
    }
  });

export default ItemView;
